<template>
    <div style="">
        login
    </div>
</template>

<script>
    import commonmix from '@/mixin/commonmix';
    import axios from 'axios';
    export default {
        name: "login",
        mixins:[commonmix],
        data(){
            return {
                id : '',
                password : '',
                isAutoLogin : false
            }
        },
        methods : {
            login(){
                var paramters = {};
                paramters.id = this.id;
                paramters.password = this.password;
                paramters.isAutoLogin = this.isAutoLogin;

                axios.post('/api/login', paramters).then(res => {
                    if(res.data.code == 0){
                        this.setLoginInfo(res.data.loginInfo);
                        if(location.search.indexOf("?return=") > -1){
                            this.$router.push({ path: this.$route.query.return});
                        }else {
                            this.$router.push({ path: '/dashboard'});
                        }

                    }else if(res.data.code == -1){
                        this.showAlert(res.data.msg);
                    }
                }).catch(res => {
                    console.log(res);
                });

                console.log(this.isAutoLogin);
            }
        },
        mounted(){

        }
    }
</script>

<style scoped>

</style>